import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A Google phone interview",
  "description": "",
  "published": "2012-03-02T00:00:00.000Z",
  "redirect_from": ["/blog/a-google-phone-interview/swizec/3813"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I had my (hopefully first rather than last) technical interview with `}<a parentName="p" {...{
        "href": "http://google.com",
        "title": "Google"
      }}>{`Google`}</a>{` `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5,-0.116666666667&spn=10.0,10.0&q=51.5,-0.116666666667%20(United%20Kingdom)&t=h",
        "title": "United Kingdom"
      }}>{`UK`}</a>{`.Short story: That stuff is fun! Longer story follows.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/450px-Google_London_UK_-_phonebox.jpg",
        "alt": "Google London HQ",
        "title": "Google London HQ"
      }}></img></p>
    <p>{`Sometime in January one of Google's recruiters sent me an email; whether I'd be interested in talking with him. That my online profile looked interesting and so on ... at first I almost dismissed it as spam - surely they send these out by the hundreds every day?`}</p>
    <p>{`But hey, nothing to lose if I reply, right?`}</p>
    <p>{`After I changed the agreed date of our video chat a couple of times - even forgot to respond to an email for two weeks - we finally got together. That was just your run of the mill blahblah with an HR person. What kind of stuff I like, what Google is all about, the fact they have shiny new offices in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5072222222,-0.1275&spn=0.1,0.1&q=51.5072222222,-0.1275%20(London)&t=h",
        "title": "London"
      }}>{`London`}</a>{` and are looking for people to fill them with and so on.`}</p>
    <p>{`Mind you, I don't know whether I actually want to work for Google. They're a huge company and working for them would fly right in the face of `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/why-i-only-work-with-startups/swizec/2936",
        "title": "Why I only work with startups"
      }}>{`my principle to only work with startups`}</a>{`! On the other hand, just being able to say I've worked at Google, even for a short while, would look `}<em parentName="p">{`incredibly`}</em>{` well on my CV.`}</p>
    <p>{`But hey, no sense worrying about this stuff until they offer me a job. Fuck it, let's give the interviewing process a shot - looks like an interesting challenge anyway. Challenge accepted, I want to win.`}</p>
    <p>{`They agreed to give me a call a month later, when I'd be done with exams. Yes, Google is in fact that nice. No rush, whenever you have time, you don't want to even consider working before September? Fine with us. Please just let us talk to you kthxbai.`}</p>
    <p>{`Yesterday was a month later.`}</p>
    <h2 {...{
      "id": "the-interview"
    }}>{`The interview`}</h2>
    <p>{`Funny thing is, Google goes to great length to put you at ease about the whole process. They're nice to you, send you friendly sounding email and at the same time everything looks `}<em parentName="p">{`so`}</em>{` bureaucratized you can't help but feel ever so slightly nervous.`}</p>
    <p>{`There's even detailed instructions for making sure you can be called via `}<a parentName="p" {...{
        "href": "http://www.google.com/talk/",
        "title": "Google Talk"
      }}>{`GTalk`}</a>{`!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/800px-Google_London_UK.jpg",
        "alt": "Google London HQ",
        "title": "Google London HQ"
      }}></img></p>
    <p>{`And the email says `}<em parentName="p">{`don't you dare type on your laptop, the `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Interview",
          "title": "Interview"
        }}>{`interviewer`}</a>{` will `}<strong parentName="em">{`hear`}</strong>{` you!`}</em>{` Of course the interviewer spent the entire conversation happily clickety-clacking away at his laptop ... it `}<em parentName="p">{`is`}</em>{` in fact slightly annoying.`}</p>
    <p>{`Andrew was a cool guy, very good with asking cool questions and letting me run amok - undoubtedly making an arse of myself several times when I climbed into a wall trying to explain a concept I introduced to the conversation and then backtracking to where I still made sense and trying to explain it differently.`}</p>
    <p>{`The conversation had a light structure, felt like having a technical chat with a friend over some drinks:`}</p>
    <ul>
      <li parentName="ul">{`describe a cool recent project, go into the technical nitty gritty`}</li>
      <li parentName="ul">{`what's an exception and how does it work`}</li>
      <li parentName="ul">{`what is a memory leak and how would you go about debugging it`}</li>
      <li parentName="ul">{`automated testing! talk, go!`}</li>
      <li parentName="ul">{`write some code to create `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Powerset"
        }}>{`powersets`}</a></li>
      <li parentName="ul">{`how would you look for a file containing a keyword in a deeply-ish nested directory structure`}</li>
    </ul>
    <p>{`I have no idea how well I answered the questions ... you know how these things are, you can explain at great detail what you `}<em parentName="p">{`think`}</em>{` something is and how it behaves. But you might well be completely wrong.`}</p>
    <p>{`The funniest part was after I explained a recent project (`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Time_series",
        "title": "Time series"
      }}>{`time-series analysis`}</a>{` for predicting how much money I'll have in two weeks) and Andrew's response was something along the lines of `}<em parentName="p">{`"Oh that's really cool! Do you have any plans on making it into a service? ... wait, I'm interviewing you for Google ..."`}</em></p>
    <p>{`He seemed a bit confused.`}</p>
    <p>{`Another interesting moment was when I was explaining `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Memory_leak",
        "title": "Memory leak"
      }}>{`memory leaks`}</a>{`. He was looking for an answer inside the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Java_%28programming_language%29",
        "title": "Java (programming language)"
      }}>{`Java`}</a>{` or C++ world (even made sure I knew them beforehand) and instead I explained that a cool way of getting memory leaks with javascript is through closures that are left hanging. I did also give the answer he was looking for, but off-handedly.`}</p>
    <p>{`That somehow sent me into a long explanation of what closures are and how the concept is neatly related to continuations and function curling. And what `}<em parentName="p">{`those`}</em>{` are. He generally let me wander around with my answers, probably trying to poke into what I do know and what I don't, even if it's beyond the scope of specific questions.`}</p>
    <h2 {...{
      "id": "coding-under-pressure"
    }}>{`Coding under pressure`}</h2>
    <p>{`There was some coding involved - a very simple task. `}<em parentName="p">{`What is a powerset,`}</em>{` blah`}<em parentName="p">{`, yes you got it. Now code something in your favorite language to turn a set into its powerset.`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/800px-Google_London_UK_-_Victoria-300x225.jpg",
        "alt": "Google London HQ",
        "title": "Google London HQ"
      }}></img></p>
    <p>{`Not even in my worst nightmare could I imagine coding live, with somebody looking directly at my output, would be `}<strong parentName="p">{`so`}</strong>{` difficult! It's amazing, you go there and you think`}<em parentName="p">{` ah! yes, I know this! This is simple stuff!`}</em></p>
    <p>{`You start ... nothing.`}</p>
    <p>{`I spent four or five attempts climbing myself into a wall and deleting all my code before finally producing a cool looking algorithm - a lovely non-recursive solution; simply because I couldn't think of a recursive solution, just knew that the simplest solution is supposed to be a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Recursion_%28computer_science%29",
        "title": "Recursion (computer science)"
      }}>{`recursive algorithm`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`def powerset(set):
      binaries = [bin(a) for a in range(2^len(set))]
      power = []
      for yeses in binaries:
        subset = []
    yeses = str(yeses)
    for i in range(len(yeses)):
                 if yeses[i] == “1”:
                subset.append(set[i])
    power.append(subset)
      return power
`}</code></pre>
    <p>{`This is whiteboard python. The syntax for calculating a power is wrong and I'm fairly certain `}<em parentName="p">{`bin`}</em>{` isn't an actual function in standard library. I'm also not sure converting a binary number to a string works quite as I envision it here, might need to use `}<em parentName="p">{`"%d" % blah`}</em>{` syntax.`}</p>
    <p>{`But the general idea is simple: take all binary numbers from zero to the powerset's length, iterate through them and use digits as binary switches for picking elements to put into each subset.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/2576981899_fef76fd366_m1.jpg",
        "alt": "Google 的貼牌冰箱（Google refrigerator）",
        "title": "Google 的貼牌冰箱（Google refrigerator）"
      }}></img></p>
    <p>{`It took me forever to deduce the formula for calculating the size of a powerset from first principles. Couldn't remember it. Looked at the examples I generated in my head ... `}<em parentName="p">{`"Ok, so every time you add an element, you double the size of the powerset. n^2 ... no that's not it ... could it possibly be 2^n? Damn it! yes, that's it!"`}</em></p>
    <p>{`But Andrew reassured me he loved the solution even though it needed a bit of fixing; and you can obviously see that's not the most elegant `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Python_%28programming_language%29",
        "title": "Python (programming language)"
      }}>{`python code`}</a>{` out there.`}</p>
    <h2 {...{
      "id": "and-now-we-wait"
    }}>{`And now we wait`}</h2>
    <p>{`In general I think I managed to convince Andrew that even though my explanations often came with a `}<em parentName="p">{`"I haven't looked into how this works `}<strong parentName="em">{`exactly, `}</strong>{`but here's my understanding of what should be going on"`}</em>{` I know a fair bit about technology and if push came to shove, I could code my way out of a wet paper bag to save a life.`}</p>
    <p>{`If he got the same impression, the next step is a full day of back-to-back technical interviews at Google's London offices.`}</p>
    <p>{`First though, we wait for "my" recruiter to get back to me about how the phone conversation went.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jhucareercenter.wordpress.com/2012/03/02/interview-like-an-ace-helpful-tips/"
        }}>{`Interview like an ace: Helpful tips`}</a>{` (jhucareercenter.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/9187448/further-clarification-of-an-ie7-memory-leak"
        }}>{`Further clarification of an IE7 Memory Leak`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gottabemobile.com/2012/03/02/google-wallet-coming-to-10-more-sprint-android-phones-in-2012/"
        }}>{`Google Wallet Coming to 10 More Sprint Android Phones in 2012`}</a>{` (gottabemobile.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://e-clecticism.blogspot.com/2012/02/image-recursion.html"
        }}>{`Image Recursion`}</a>{` (e-clecticism.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/9509060/appending-title-to-google-event-tracking-code"
        }}>{`Appending Title to Google Event Tracking Code`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.zemanta.com/blog/semantic-tech-conference-quick-report/"
        }}>{`Semantic Tech Conference quick report`}</a>{` (zemanta.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5ef03a4a-3086-4972-b4f6-b6ac07633ebd",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      